import { render, staticRenderFns } from "./ProductFactors.vue?vue&type=template&id=3c25c058&scoped=true&"
import script from "./ProductFactors.vue?vue&type=script&lang=js&"
export * from "./ProductFactors.vue?vue&type=script&lang=js&"
import style0 from "./ProductFactors.vue?vue&type=style&index=0&id=3c25c058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c25c058",
  null
  
)

export default component.exports